module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/3/video-preview-4-e5446566711d72229f6319954af15834.png";